export type HeaderUserRole = 'guest' | 'user' | 'member' | 'owner';

export interface HeaderTeamAccount {
  id: string;
  slug: string | null;
  name: string;
  is_personal_account: boolean;
}

export interface HeaderMembership {
  account_role: string;
  accounts: HeaderTeamAccount | null;
}

/** `null` means the browser no longer holds a usable session. */
export function toHeaderUserRole(
  memberships: HeaderMembership[] | null,
): HeaderUserRole {
  if (memberships === null) return 'guest';
  if (memberships.length === 0) return 'user';

  return memberships.some((membership) => membership.account_role === 'owner')
    ? 'owner'
    : 'member';
}

export function toHeaderTeamAccount(memberships: HeaderMembership[] | null) {
  return (
    memberships?.find(
      (membership) => membership.accounts?.is_personal_account === false,
    )?.accounts ?? null
  );
}
